import WebinarList from './WebinarList';
import WebinarItem from './WebinarItem';
import WebinarSlider from './WebinarSlider';
import WebinarOverview from './WebinarOverview';
import WebinarInnerInfo from './WebinarInnerInfo';
import WebinarInfo from './WebinarInfo';
import SeriesSlider from './SeriesSlider';
import SeriesInfo from './SeriesInfo';
import ModuleSlider from './ModuleSlider';
import ModuleVideo from './ModuleVideo';
import NextModulesSlider from './NextModulesSlider';

export {
    WebinarList,
    WebinarItem,
    WebinarSlider,
    WebinarOverview,
    WebinarInnerInfo,
    WebinarInfo,
    SeriesSlider,
    SeriesInfo,
    ModuleSlider,
    ModuleVideo,
    NextModulesSlider,
}


// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/index.js